import { render, staticRenderFns } from "./CommonNotificationsBadge.vue?vue&type=template&id=1c41c98e"
import script from "./CommonNotificationsBadge.vue?vue&type=script&lang=js"
export * from "./CommonNotificationsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports